(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPager(root){
    if(!root || root.dataset.revPagerInit) return;
    var grid=root.querySelector('.rev-grid');
    var pager=root.querySelector('[data-rev-pager]');
    if(!grid||!pager) return;
    var cards=Array.prototype.slice.call(grid.querySelectorAll('.rev'));
    var per=parseInt(root.getAttribute('data-per-page'),10)||6;
    if(cards.length<=per) return;
    root.dataset.revPagerInit='1';
    var pages=Math.ceil(cards.length/per), current=1;
    function mk(label,enabled,fn,active){
      var b=document.createElement('button');
      b.type='button'; b.className='rev-page-btn'+(active?' is-active':''); b.textContent=label;
      if(active) b.setAttribute('aria-current','true');
      if(!enabled){ b.disabled=true; } else { b.addEventListener('click',fn); }
      return b;
    }
    function go(p){ if(p<1||p>pages||p===current) return; current=p; render(); grid.scrollIntoView({block:'nearest'}); }
    function render(){
      cards.forEach(function(c,i){ c.style.display=(Math.floor(i/per)+1===current)?'':'none'; });
      pager.innerHTML='';
      var prev=mk('\u2039',current>1,function(){go(current-1);},false); prev.setAttribute('aria-label','Previous'); pager.appendChild(prev);
      for(var p=1;p<=pages;p++){ (function(p){ pager.appendChild(mk(String(p),true,function(){go(p);},p===current)); })(p); }
      var next=mk('\u203a',current<pages,function(){go(current+1);},false); next.setAttribute('aria-label','Next'); pager.appendChild(next);
    }
    pager.hidden=false; render();
  }
  function run(scope){ (scope||document).querySelectorAll('[data-rev-paginate]').forEach(initPager); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){run(document);}); } else { run(document); }
  document.addEventListener('shopify:section:load',function(e){ run(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function relDate(days) {
    days = parseInt(days, 10) || 0;
    if (days <= 1) return '1 day ago';
    if (days < 7) return days + ' days ago';
    if (days < 14) return '1 week ago';
    if (days < 56) return Math.floor(days / 7) + ' weeks ago';
    if (days < 90) return '1 month ago';
    return Math.floor(days / 30) + ' months ago';
  }

  function initRoot(root) {
    if (!root || root.__rvInit) return;
    root.__rvInit = true;

    var list = root.querySelector('[data-rv-list]');
    if (!list) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rv-card]'));
    var moreBtn = root.querySelector('[data-rv-more]');
    var showingEl = root.querySelector('[data-rv-showing]');
    var emptyEl = root.querySelector('[data-rv-empty]');
    var initShow = parseInt(root.getAttribute('data-rv-init-show'), 10) || 6;
    var batch = parseInt(root.getAttribute('data-rv-batch'), 10) || 6;
    var state = { filter: 'all', shown: initShow };

    root.querySelectorAll('[data-rv-days-label]').forEach(function (el) {
      el.textContent = relDate(el.textContent.trim());
    });

    function eligible() {
      return cards.filter(function (c) {
        return state.filter === 'all' || c.getAttribute('data-rv-rating') === state.filter;
      });
    }
    function render() {
      var elig = eligible();
      cards.forEach(function (c) { c.classList.add('is-hidden'); });
      elig.slice(0, state.shown).forEach(function (c) { c.classList.remove('is-hidden'); });
      if (emptyEl) emptyEl.hidden = elig.length !== 0;
      if (moreBtn) moreBtn.hidden = state.shown >= elig.length;
      if (showingEl) {
        var visible = Math.min(state.shown, elig.length);
        showingEl.textContent = elig.length ? ('Showing ' + visible + ' of ' + elig.length) : '';
      }
    }
    function sortByRecent() {
      cards.sort(function (a, b) {
        return (+a.getAttribute('data-rv-days')) - (+b.getAttribute('data-rv-days'));
      });
      cards.forEach(function (c) { list.appendChild(c); });
    }

    root.querySelectorAll('[data-rv-filter]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        root.querySelectorAll('[data-rv-filter]').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        state.filter = chip.getAttribute('data-rv-filter');
        state.shown = initShow;
        render();
      });
    });
    if (moreBtn) moreBtn.addEventListener('click', function () { state.shown += batch; render(); });

    root.querySelectorAll('[data-rv-helpful-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-voted')) return;
        var cnt = btn.querySelector('[data-rv-helpful-count]');
        if (cnt) cnt.textContent = (parseInt(cnt.textContent, 10) || 0) + 1;
        btn.classList.add('is-voted');
      });
    });

    var modal = root.querySelector('[data-rv-modal]');
    var toast = root.querySelector('[data-rv-toast]');
    var pickedRating = 0;
    root.querySelectorAll('[data-rv-open]').forEach(function (b) { b.addEventListener('click', function () { if (modal) modal.hidden = false; }); });
    root.querySelectorAll('[data-rv-close]').forEach(function (b) { b.addEventListener('click', function () { if (modal) modal.hidden = true; }); });

    var picker = root.querySelector('[data-rv-picker]');
    if (picker) {
      var rStars = Array.prototype.slice.call(picker.querySelectorAll('[data-rv-rate]'));
      rStars.forEach(function (star) {
        star.addEventListener('click', function () {
          pickedRating = +star.getAttribute('data-rv-rate');
          rStars.forEach(function (s2) { s2.classList.toggle('is-on', +s2.getAttribute('data-rv-rate') <= pickedRating); });
        });
      });
    }
    var submit = root.querySelector('[data-rv-submit]');
    if (submit) submit.addEventListener('click', function () {
      var nameEl = root.querySelector('[data-rv-input-name]');
      var bodyEl = root.querySelector('[data-rv-input-body]');
      if (!pickedRating || !(nameEl && nameEl.value.trim()) || !(bodyEl && bodyEl.value.trim())) {
        alert('Please add a rating, your name, and a review.');
        return;
      }
      if (modal) modal.hidden = true;
      if (toast) { toast.hidden = false; setTimeout(function () { toast.hidden = true; }, 3200); }
      pickedRating = 0;
      if (picker) picker.querySelectorAll('[data-rv-rate]').forEach(function (s2) { s2.classList.remove('is-on'); });
      root.querySelectorAll('[data-rv-input-name],[data-rv-input-title],[data-rv-input-body]').forEach(function (f) { f.value = ''; });
    });

    sortByRecent();
    render();
  }

  function initAll() { document.querySelectorAll('[data-rv-root]').forEach(initRoot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-rv-root]');
    if (root) initRoot(root);
  });
})();

/* marquee: wrap cards in a duplicated track for a seamless loop (marquee layout only) */
(function(){function mq(scope){(scope||document).querySelectorAll('.rv-lay-marquee .rv-list').forEach(function(list){if(list.dataset.marq)return;list.dataset.marq='1';var track=document.createElement('div');track.className='rv-track';while(list.firstChild){track.appendChild(list.firstChild);}track.querySelectorAll('.rv-card.is-hidden').forEach(function(c){c.classList.remove('is-hidden');});track.innerHTML+=track.innerHTML;list.appendChild(track);});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){mq(document);});}else{mq(document);}document.addEventListener('shopify:section:load',function(e){mq(e.target);});})();

  } catch(e) { console.error(e); }
})();
})();
